export default __webpack_public_path__ + "static/media/fitting.395ba2a3.jpg";